import React from "react";

import { Card, Nav, Container, Row, Col, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import ListCabang from "./ListCabang";
import ListCabangSyariah from "./ListCabangSyariah";

function IndexUser() {
  const auth = useSelector((state) => state.authReducer);
  const [status, setStatus] = React.useState("");

  // React.useEffect(() => {
  //   setStatus(auth.role);
  // }, [auth.role]);
  return (
    <>
      <Container fluid className="pt-3">
        <Row>
          <Col md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px", overflow: "hidden" }}
            >
              {/* HEADER DENGAN AKSEN NAVY KONSISTEN */}
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "12px",
                      height: "30px",
                      backgroundColor: "#1D3557",
                      borderRadius: "10px",
                      marginRight: "15px",
                    }}
                  />
                  <Card.Title
                    as="h3"
                    style={{
                      color: "#1e293b",
                      textTransform: "uppercase",
                      fontWeight: "800",
                      margin: 0,
                      letterSpacing: "1px",
                    }}
                  >
                    Daftar Cabang BPD
                  </Card.Title>
                </div>
                <p
                  className="text-muted mt-2 ml-4"
                  style={{ fontSize: "14px" }}
                >
                  Manajemen data kantor cabang berdasarkan kategori operasional.
                </p>
              </Card.Header>

              <Card.Body className="px-4 pb-4">
                <Tab.Container
                  id="branch-management-tabs"
                  defaultActiveKey="konvensional"
                >
                  {/* NAVIGASI TAB PILLS DENGAN AKSEN IKON */}
                  <Nav
                    variant="pills"
                    className="mb-4 p-2 bg-light"
                    style={{
                      borderRadius: "15px",
                      display: "inline-flex",
                      width: "auto",
                    }}
                  >
                    <Nav.Item>
                      <Nav.Link
                        eventKey="konvensional"
                        className="custom-branch-tab d-flex align-items-center"
                      >
                        <i className="fas fa-building mr-2"></i>
                        <span>KONVENSIONAL</span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="syariah"
                        className="custom-branch-tab d-flex align-items-center"
                      >
                        <i className="fas fa-mosque mr-2"></i>
                        <span>SYARIAH</span>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content className="mt-2 animation-fade">
                    <Tab.Pane eventKey="konvensional">
                      <ListCabang />
                    </Tab.Pane>
                    <Tab.Pane eventKey="syariah">
                      <ListCabangSyariah />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* STYLING KHUSUS UNTUK TAB CABANG */}
        <style>{`
    .custom-branch-tab {
      color: #64748b !important;
      font-weight: 800 !important;
      border-radius: 12px !important;
      padding: 12px 25px !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      background: transparent !important;
      font-size: 13px;
      letter-spacing: 0.5px;
    }
    
    .custom-branch-tab.active {
      background-color: #1D3557 !important;
      color: white !important;
      box-shadow: 0 4px 15px rgba(29, 53, 87, 0.25) !important;
    }

    .custom-branch-tab:hover:not(.active) {
      color: #1D3557 !important;
      background-color: #e2e8f0 !important;
    }

    /* Animasi halus saat ganti tab */
    .animation-fade {
      animation: fadeIn 0.4s ease-in-out;
    }

    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(5px); }
      to { opacity: 1; transform: translateY(0); }
    }

    /* Responsive untuk Mobile */
    @media (max-width: 576px) {
      .nav-pills {
        display: flex !important;
        width: 100% !important;
      }
      .nav-item {
        flex: 1;
        text-align: center;
      }
      .custom-branch-tab {
        padding: 12px 10px !important;
        justify-content: center;
        font-size: 11px;
      }
    }
  `}</style>
      </Container>
    </>
  );
}

export default IndexUser;
